import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PerformanceMetricsService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/performancemetrics`;

  constructor(private http: HttpClient) { }

  get(userId: number): Observable<Boo.Objects.UserPerformanceSummary> {
    const params = new HttpParams().set('userId', userId);

    return this.http.get<Boo.Objects.UserPerformanceSummary>(this.baseUrl, { params: params });
  }
}
